<template>
  <section class="row">
    <div class="col-12 col-lg-9 mx-auto">
      <h5 class="mb-3">
        <v-highlight color="pink-300">
          La date d’effet
        </v-highlight>
        de mes modifications
      </h5>
      <p class="my-3">
        Selon la date d’effet choisie, le tarif de votre contrat peut varier.
      </p>
      <p
        v-if="isRnAndNowBeforeStartCover"
        class="text-danger"
      >
        Votre contrat est en renouvellement. Vos modifications seront prises en compte à partir
        du {{ startCoverFormat }}
      </p>
      <v-calendar
        input-id="amendment-date"
        module-name="contract"
        label="Choisir la date d’effet de votre avenant"
        getter-name="get"
        :getter-function="getEffectiveDate"
        setter-name="updateEffectiveDateAmendment"
        path="effectiveDate"
        :disabled-dates="{ to: disabledDates }"
      />
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';

import Calendar from '@/components/common/input/Date2.vue';

export default {
  name: 'PricingEffectiveDate',
  components: {
    'v-calendar': Calendar,
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      contract: 'contract/get',
    }),
    disabledDates() {
      if (this.isRnAndNowBeforeStartCover) {
        const effectiveDate = new Date(this.contract.startCover);
        return effectiveDate;
      }
      const effectiveDate = new Date(this.getEffectiveDate(this.contract));
      const todayInteger = Date.now();
      if (todayInteger > effectiveDate.getTime()) {
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        return yesterday;
      }
      return effectiveDate;
    },
    startCoverFormat() {
      try {
        const date = new Date(this.contract.startCover);
        let day = date.getDate();
        let month = date.getMonth() + 1;
        const year = date.getFullYear();

        if (day < 10) day = `0${day}`;
        if (month < 10) month = `0${month}`;
        return [day, month, year].join('/');
      } catch {
        return '';
      }
    },
    isRnAndNowBeforeStartCover() {
      return this.contract.type === 'RN' && Date.now() < new Date(this.contract.startCover).getTime();
    },
  },
  methods: {
    updateDate(value) {
      this.$store.dispatch('contract/updateSubscription', { path: 'effectiveDate', value });
    },
    getEffectiveDate(contract) {
      if (contract.versions) {
        const { versions } = this.contract;
        return versions[versions.length - 1].effectiveDate;
      }
      return contract.effectiveDate;
    },
  },
};
</script>
